import React from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'

type Props = {
  icon: string
  text: string
}

const HelpBubble = ({icon, text}: Props) => {
  return (
    <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed  p-6 mb-10'>
      <KTSVG path={icon} className='svg-icon-2tx svg-icon-warning me-4' />
      <div className='d-flex fw-bold flex-grow-1 justify-content-start  '>
        <p className='text-gray-700 fw-bold fs-6   '>{text}</p>
      </div>
    </div>
  )
}

export default HelpBubble
